var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navigation-menu-item',{attrs:{"target-path":"balance","title":"יתרת העו״ש וחיובי האשראי","disabled":!_vm.allowNavigationToBalancePage},on:{"navigate":function($event){return _vm.$emit('navigate')}}})}
var staticRenderFns = []

export { render, staticRenderFns }